import React, { Fragment } from 'react'
import { Alert } from "react-bootstrap"

import Constants from '../../config.js'
import { getLog } from '../../helpers/helpers.js'
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import ClickToOpenCardDark from '../../components/ClickToOpenCardDark.js'
import { SlidePopup } from '../../components/WithPopup/TextCopyQR.js'
import { translateErrorToJSXMessage } from "../../translateErrorToJSXMessage.js"
import ButtonParam from './ButtonParam.js'


/**
 * Cache section — erase transaction history cache, open cache folder.
 *
 * Props:
 *   - run: the Run instance (or null while loading)
 */
class SectionCache extends React.Component {

	static contextType = UserContext

	constructor(props) {
		super(props)
		this.classname = "Slide_Settings/SectionCache: "

		this.state = {
			error_jsx: null,
		}

		this.handleClick_clearHistoryCache = this.handleClick_clearHistoryCache.bind(this)
	}

	async handleClick_clearHistoryCache() {
		const function_id = this.classname + "handleClick_clearHistoryCache(): "

		let message = "⚠️ Effacer le cache nécessitera de reconstruire tout l'historique depuis la blockchain, cela peut prendre un certain temps ⚠️"

		let didconfirm = false
		if (!Constants.IS_WEB_BUILD) {
			let options = { title: "Warning", message: message, buttons: ['Continue', 'Cancel'], defaultId: 1 }
			await window.electron.openDialogShowMessageBox(options).then((resdata) => {
				if (resdata.response === 0) didconfirm = true
			})
		} else {
			didconfirm = window.confirm(message)
		}
		if (didconfirm === false) return

		try {
			await this.context.clearCache()
			this.context.reset_cache_history_bsv()
		} catch (error) {
			this.setState({
				error_jsx: (
					<SlidePopup onButtonClick={() => { this.setState({ error_jsx: null }) }}>
						{translateErrorToJSXMessage(error)}
					</SlidePopup>
				)
			})
		}
		this.context.reload_wallet()
	}

	render() {
		const run = this.props.run
		const buttonsCustomStyle = {
			cursor: run ? "pointer" : "not-allowed",
			backgroundColor: run ? "" : "grey",
			pointerEvents: run ? "auto" : "none"
		}

		let cache_folder_path = null
		let cache_folder_path_raw = null
		try {
			if (run) {
				cache_folder_path = run.cache.get_path()
				cache_folder_path_raw = run.cache.get_path_raw()
			}
		} catch (e) { }

		return (
			<Fragment>
				{this.state.error_jsx ? <div><br />{this.state.error_jsx}<br /></div> : null}

				<ClickToOpenCardDark title="Cache">
					<center><br />
						<ButtonParam onClick={this.handleClick_clearHistoryCache} style={buttonsCustomStyle}>
							Erase the cache of transaction history
						</ButtonParam>
						<br /><br />

						{cache_folder_path ?
							<Fragment>
								<ButtonParam
									onClick={() => { window.electron.openFolderInExternalWindow(cache_folder_path) }}
								>
									Open cache folder
								</ButtonParam><br /><br />
							</Fragment>
							:
							(Constants.IS_WEB_BUILD ? null :
								<Fragment>
									<ButtonParam
										style={{ backgroundColor: "grey", pointerEvents: "none" }}
										onClick={() => { window.electron.openFolderInExternalWindow(cache_folder_path) }}
									>
										(dev mode: no cache folder)
									</ButtonParam><br /><br />
								</Fragment>
							)
						}

						{Constants.IS_WEB_BUILD ? null :
							<span style={{ wordBreak: "break-all" }}>
								Cache File: {cache_folder_path_raw ? cache_folder_path_raw : "(dev mode: no cache folder)"}
							</span>
						}
						<br />
					</center>
				</ClickToOpenCardDark>
				<br />
			</Fragment>
		)
	}
}

export default SectionCache
